export default class AbstractUpload {
  /**
   * Create a file upload
   *
   * @param {Number} maximumSize
   * @param {string} accept
   */
  constructor (maximumSize, maximumSizeErrorMessage, accept, acceptErrorMessage, value, options) {
    this.maximumSize = maximumSize
    this.maximumSizeErrorMessage = maximumSizeErrorMessage
    this.accept = accept
    this.acceptErrorMessage = acceptErrorMessage
    this.options = options || {}

    this._value = value || null
  }
}
